import { render, staticRenderFns } from "./RotateScreen.vue?vue&type=template&id=6aec28fc&scoped=true"
import script from "./RotateScreen.vue?vue&type=script&lang=ts"
export * from "./RotateScreen.vue?vue&type=script&lang=ts"
import style0 from "./RotateScreen.vue?vue&type=style&index=0&id=6aec28fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aec28fc",
  null
  
)

export default component.exports